<!--商品详情-->
<template>
  <div class="box">
    <!--<div class="goods-header">
     <div class="header-left" @click="goBusiness">
        <img :src="detail.business_pic_url" alt="">
        <div class="haeder-user-text">{{detail.business_name}}</div>
    </div>-->
    <!--<div class="header-left" @click="goHome" v-else>
          <img :src="header.logo" alt="">
          <div class="haeder-user-text">{{header.name}}</div>
      </div>
      <div class="header-right flex-end">
        <span @click="goOrderList">我的订单</span>
      </div>
    </div>-->

    <div class="goods-banner">
      <van-swipe indicator-color="#FD2840" :duration="duration">
        <van-swipe-item v-if="detail.videos_url" @click="toGoodsVideo">
          <img :src="detail.videos_url" alt v-lazy="detail.videos_url" />
          <img src="../../../assets/images/icon-video-play.png" class="video-img" alt />
        </van-swipe-item>
        <van-swipe-item v-for="item in detail.pics_url" :key="item.id">
          <img :src="item" alt />
        </van-swipe-item>
      </van-swipe>
      <!--			<img src="../../../assets/newImg/pic-goods-detail-banner.png" alt="">-->
    </div>
    <div class="goods-name">{{detail.title}}</div>
    <div class="goods-detail">
      <div class="goods-pri">
        <div class="goods-price">
          ¥
          <span>{{detail.price_range[0]|price}}</span>
        </div>
        <div class="goods-price-thr gray-light">¥{{detail.orig_price|price}}</div>
        <div class="good-pri-earn" v-if="detail.max_seller_reward>0" @click="onRule">
          <div>分享可赚￥{{detail.max_seller_reward/100</div>
          <img src="https://static.dierqudao.com/images/icon-questionred.png" alt />
        </div>
      </div>
      <div class="row-yf gray">
        <div class="row-left">已售 {{detail.sold_count + detail.sold_show_count}}</div>
        <div class="row-right-yf">
          运费 ¥
          <span
            v-if="detail.express_price[0] == detail.express_price[1]"
          >{{detail.express_price[0]/100</span>
          <span v-else>{{detail.express_price[0]/100 +'-'+ detail.express_price[1]/100</span>
        </div>
      </div>

      <!--<div class="flex-between share">
          <div class="row-xg gray">
              <img src="../../../assets/newImg/icon-go.png" alt="">每人限购2件
          </div>
      </div>-->

      <div class="share-box share-right">
        <div class="share-right-text" v-if="detail.max_seller_reward>0" @click="getShare">
          分享好友可赚
          <div>￥{{detail.max_seller_reward/ 100}}</div>
        </div>
        <div class="share-right-texts" v-else @click="getShare">分享给好友</div>
      </div>

      <!--<div class="row-tips" v-if="detail.discount_tags.length > 0">
        <GoodsDetailTips :discount="detail.discount_tags"></GoodsDetailTips>
      </div>-->
    </div>
    <!--<div class="shop-box" @click="goBaseDetail(detail.business_id)">
      <div class="shop-left">
        <img :src="detail.business_pic_url" alt="">
        <div class="shop-text">
          <div class="shop-name">{{detail.business_name}}</div>
          <div class="shop-det gray">{{detail.business_desc}}</div>
        </div>
    </div>-->
    <!--            <div class="shop-right gray-light">-->
    <!--   <div class="shop-right flex-end">
        <div>去逛逛</div>
        <img class="row-right" src="../../../assets/images/icon-right.png" alt="">
      </div>
    </div>-->

    <div class="row-list app-border-top">
      <div class="app-border-bottom flex-between row-one" v-for="(item,index) in detail.extra_data">
        <span>{{item.name}}</span>
        <span>{{item.value}}</span>
      </div>
    </div>
    <!--<van-cell-group class="row-group">
        <van-cell :title="item.name" :value="item.value" v-for="item in detail.extra_data" :key="item.id"/>
        &lt;!&ndash;<van-cell title="发货时效" value="72小时" />
        <van-cell title="保存" value="冷藏2-3天" />&ndash;&gt;
    </van-cell-group>-->
    <!--<div class="remark-box">
        <div class="remark-header">
            <div class="remark-text">点评</div>
            <div class="remark-good gray">
                好评度 <span>98%</span><img class="row-right" src="../../../assets/images/icon-right.png" alt="">
            </div>
        </div>

    </div>
    <div class="remark-list">
        <div class="remark-li">
            <img src="../../../assets/newImg/Group5.png" alt="">
        </div>
    </div>-->
    <div class="detail-title">
      <div></div>
      <span>商品详情</span>
      <div></div>
    </div>
    <div class="detail-img" v-html="detail.content"></div>
    <CopyRight></CopyRight>
    <van-goods-action class="goods-footer">
      <!--<van-goods-action-icon class="footer-kf" @click="goHome" icon="home-o">
        <p>首页</p>
      </van-goods-action-icon>
      <van-goods-action-icon class="footer-kf" icon="chat-o" @click="onChat">
        <p>客服</p>
      </van-goods-action-icon>-->
      <!--<van-goods-action-icon
        class="footer-kf"
        :info="cart_count"
        @click="goCart"
        v-if="cart_count> 0"
        icon="cart-o"
      >
        <p>购物车</p>
      </van-goods-action-icon>
      <van-goods-action-icon class="footer-kf" @click="goCart" v-else icon="cart-o">
        <p>购物车</p>
      </van-goods-action-icon>-->

     <!-- <van-goods-action-button text="加入购物车" type="warning" @click="showSkuPicker = true" />-->
      <van-goods-action-button primary text="立即购买" type="danger" @click="showSkuPicker = true" />
    </van-goods-action>
    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>

    <!-- 基础用法 -->
    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :quota="skuData.quota"
        :quota-used="skuData.quotaUsed"
        :custom-stepper-config="customStepperConfig"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
      />
    </div>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    <ShareDialog
      :show="shareShow"
      :reward="detail.max_seller_reward"
      :goods_id="detail.id"
      :share="share"
      @shareCancel="shareCancel"
    />
    <!--<ActivityDialog :row="detail.activity"></ActivityDialog>-->
    <BookDialog
      :show="bookDialogShow"
      :wxNote="chat.note"
      :wxCode="chat.wxcode"
      :wxPic="chat.pic_url"
      :phone="chat.phone"
      @onBookCancle="onBookCancle"
    ></BookDialog>
  </div>
</template>
<style scoped>
.box {
  margin-bottom: 50px;
}

.van-swipe .video-img {
  position: absolute;
  left: 3.25rem;
  top: 2.1rem;
  z-index: 20px;
  width: 50px;
  height: 50px;
}

.copybox {
  padding: 0.2rem 0 0.6rem;
}

.share {
  /*border-bottom: 1px solid #EFEFEF;*/
  padding-bottom: 0.1rem;
}

.shareShow {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  z-index: 10000;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.68);
  color: rgb(255, 255, 255);
}

.shareShow div {
  background: url(https://static.dierqudao.com/images/cheesemanv2.0/icon_share_arrow.png)
    no-repeat right top;
  height: 100%;
  background-size: 100px;
  padding: 180px 0 0 0;
  margin: 10px;
  line-height: 40px;
}

.shareShow h2 {
  /*font-size: 1.8rem*/
  font-size: 0.8rem;
}

.share-box {
  position: fixed;
  right: 20px;
  /*top: 60%;*/
  top: 53%;
  z-index: 8;
}

.share-right {
  margin-right: -50px;
  width: 153px;
  height: 49px;
  line-height: 49px;
  background: linear-gradient(
    180deg,
    rgba(255, 101, 131, 1) 0%,
    rgba(253, 53, 76, 1) 100%
  );
  box-shadow: 0px 2px 6px 0px rgba(255, 66, 90, 1);
  border-radius: 46px;
  text-align: center;
}

.share-right-text {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.share-right-texts {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
}

.van-goods-action-icon__icon {
  color: #7d7e80;
  font-size: 20px;
}

.sku-container >>> .van-button--warning {
  color: #fff;
  background-color: #f44;
  border: 1px solid #f44;
}

.sku-container >>> .van-button--danger {
  color: #fff;
  background-color: #ff976a;
  border: 1px solid #ff976a;
}

.row-list {
  color: #181818;
  font-size: 12px;
  padding: 0 15.5px;
}

.row-one {
  padding: 15.5px 0;
}

.app-border-top {
  border-top: 0.1rem solid #efefef;
}

.app-border-bottom {
  border-bottom: 1px solid #efefef;
}

.flex-end {
  justify-content: flex-end;
}

.header-user-text {
  width: 80px;
  text-align: center;
}

.goods-header {
  height: 45px;
  /*line-height: 45px;*/
  background: #e43131;
  color: #fff;
  padding-right: 0.2rem;

  display: flex;
  justify-content: space-between;
}

.header-left {
  width: 2.5rem;
  background: #ae1f1f;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  font-size: 12px;
  padding-left: 0.2rem;

  float: left;
}

.header-left img {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  margin-right: 0.1rem;
}

.header-right {
  width: 250px;
  height: 45px;
  color: #fff;
}

.goods-banner img {
  width: 100%;
  height: 100%;
}

.goods-name {
  font-size: 15px;
  padding: 0.15rem 0.13rem;
}

.goods-detail {
  padding: 0 0.3rem;
}

.goods-pri {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.good-pri-earn {
  width: auto;
  padding: 2px 2px;
  background: rgba(253, 232, 234, 1);
  border-radius: 2px;
  /* border:2rpx solid rgba(253,40,64,1); */
  font-size: 12px;
  color: #fd2840;
  text-align: center;
  margin-left: 7.5px;
  display: flex;
}

.good-pri-earn img {
  width: 12px;
  height: 12px;
  padding: 2px 4px;
}

.goods-price {
  font-size: 12px;
  color: #fd2840;
}

.goods-price span {
  font-size: 16px;
  font-weight: 500;
}

.goods-price-thr {
  font-size: 12px;
  text-decoration: line-through;
  margin: 3px 0 0 0.3rem;
}

.row-yf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0.2rem 0;
  border-bottom: 1px solid #efefef;
}

.row-xg {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  padding: 0.2rem 0;
  /*border-bottom: 1px solid #EFEFEF;*/
}

.row-xg img {
  margin-right: 0.15rem;
}

.row-right {
  width: 16px;
  height: 16px;
  margin-right: 0.1rem;
}

.row-tips {
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #efefef;
}

.shop-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.21rem;
}

.shop-left img {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 100%;
  margin-right: 0.2rem;
}

.shop-left,
.shop-right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.shop-right img {
  width: 16px;
  height: 16px;
}

.shop-name {
  font-size: 13px;
}

.shop-right {
  font-size: 12px;
  /*margin-right: 0.2rem;*/
}

.shop-det {
  font-size: 11px;
}

.shop-text {
  height: 100%;
  max-width: 240px;
}

.row-group {
  border-top: 0.1rem solid #efefef;
}

/* .row-group::after{
      border: none;
  } */
.row-group .van-cell {
  width: auto;
  color: #181818;
  font-size: 12px;
  padding: 0.2rem 0;
  margin: 0 0.31rem;
  border-bottom: 1px solid #efefef;
}

.remark-box {
  padding: 0 0.3rem;
}

.remark-header {
  padding: 0.3rem 0;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.remark-good {
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.remark-good span {
  color: #fd2840;
  margin-left: 0.1rem;
}

.remark-li img {
  width: 7.09rem;
  height: 3.93rem;
}

.detail-title {
  width: 7.5rem;
  line-height: 0.5rem;
  height: 0.5rem;
  background: rgba(239, 239, 239, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-title div {
  width: 0.62rem;
  height: 1px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.08;
}

.detail-title span {
  margin: 0 0.2rem;
}

.detail-img >>> img {
  width: 100%;
  margin-bottom: 50px;
}

.detail-img >>> video {
  width: 100%;
}

.like-goods {
  padding: 0 0.23rem;
  background: rgba(239, 239, 239, 1);
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.like-one {
  background: #fff;
  width: 3.45rem;
  margin-bottom: 0.2rem;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.like-one:nth-child(2n) {
  margin-left: 0.13rem;
}

.like-goods-img {
  width: 3.45rem;
  height: 3.45rem;
}

.like-one-name {
  color: #333333;
  height: 0.8rem;
  line-height: 0.4rem;
  font-weight: 500;
  padding: 0 0.2rem;
}

.like-one-pri {
  margin: 0.2rem;
}

.like-one-pri span {
  padding: 2px 3px;
  background: #fd2840;
  font-size: 9px;
  color: #fff;
  border-radius: 2px;
}

.like-one-price {
  padding: 0.2rem;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.like-red-price {
  color: #fd2840;
}

.like-big-pri {
  font-size: 17px;
}

.like-price-thr {
  text-decoration: line-through;
  margin-left: 0.1rem;
}

.footer-kf {
  align-items: center;
}

.footer-kf img {
  width: 20px;
  height: 20px;
  margin: -5px 0 5px 0;
}
</style>

<script>
import Vue from "vue";
import LoginDialog from "@/components/LoginDialog.vue";
import ShareDialog from "@/components/ShareDialog.vue";
import ActivityDialog from "@/components/ActivityDialog.vue";
import BookDialog from "@/components/BookDialog.vue";

import {
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Toast
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Sku)
  .use(Toast);
import GoodsDetailTips from "@/components/GoodsDetailTips.vue";
import CopyRight from "@/components/CopyRight.vue";

export default {
  name: "GoodsDetailSellerShare",
  components: {
    GoodsDetailTips,
    LoginDialog,
    ShareDialog,
    ActivityDialog,
    BookDialog,
    CopyRight
  },
  data: function() {
    return {
      bookDialogShow: false,
      loginShow: false,
      shareShow: false,
      detail: {
        videos_url: "",
        pics_url: [],
        price_range: [],
        express_price: [],
        activity: {},
        discount_tags: []
      },
      header: {},
      business: {},
      share: {},
      chat: {},

      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: [],
          messages: []
        },
        goods: {},
        goods_id: 0,
        quota: 0,
        quotaUsed: 0
      },
      showSkuPicker: false,
      closeOnClickOverlay: true,
      showWxShare: false,
      messageConfig: {},
      cart_count: 0,

      duration: 300,
      customStepperConfig: {
        quotaText: ""
      },
      business_id: 0,
      businessLogo: ""
    };
  },
  filter: {},
  mounted() {
    document.title = "商品详情";
    let that = this;
    that.getGoodsDetail();

    let href = window.location.href.split("#");
    if (href[1] == "share") {
      that.showWxShare = true;
    }

    that.business_id = localStorage.getItem("_business_id");
  },
  destroyed() {},
  methods: {
    getGoodsDetail() {
      let id = this.$route.query.id;
      let that = this;
      let sku = {};
      let total = 0;

      this.$api.get("/api/goods/goodsdetail", { id: id }, res => {
        that.detail = res.data.data;
        that.header = res.data.header;
        that.share = res.data.share;
        that.chat = res.data.chat;
        that.cart_count = res.data.h5_cart_count;

        that.skuData.sku = sku = res.data.sku;
        that.skuData.sku.messages = [];

        that.wxShare(
          res.data.share.title,
          res.data.share.desc,
          res.data.share.url,
          res.data.share.pic_url
        );
        that.skuData.goods = {
          title: that.detail.title,
          picture: that.detail.pic_url
        };

        // 总数量
        for (let i = 0; i < sku.list.length; i++) {
          total = total + sku.list[i].stock_num;
        }

        that.skuData.sku.stock_num = total;
        that.skuData.sku.price =
          that.detail.price_range[0] / 100 +
          "-" +
          that.detail.price_range[1] / 100;
        that.skuData.goods_id = that.detail.id;
        that.skuData.quota = that.detail.user_buy_limit;
        that.skuData.quotaUsed = that.detail.buy_count;
        if (that.skuData.quota > 0) {
          that.customStepperConfig.quotaText =
            "(每人限购" + that.skuData.quota + "件)";
        }
      });
    },

    // 跳转商品视频
    toGoodsVideo() {
      let id = this.$route.query.id;
      this.$router.push({
        path: "/goodsvideo",
        query: {
          id: id
        }
      });
    },

    onRule() {
      this.$router.push({
        path: "/index/contentdetail",
        query: {
          id: 8
        }
      });
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      let that = this;
      that.loginShow = false;
      // that.showSkuPicker = true
      that.getGoodsDetail();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      this.loginShow = false;
    },

    onChat() {
      if (!this.chat.wxcode) {
        Toast("商户暂未配置");
        return;
      }
      this.bookDialogShow = true;
    },

    onBookCancle() {
      this.bookDialogShow = false;
    },

    shareCancel() {
      console.log("-------取消分享-------");
      this.shareShow = false;
    },
    onShareCancel() {
      this.showWxShare = false;
    },

    getShare() {
      let that = this;
      that.$api.get(
        "/api/cart/detail",
        {},
        res => {
          that.shareShow = true;
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    goBaseDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/basedetail",
        query: {
          id: id
        }
      });
    },

    // 立即购买
    onBuyClicked(data) {
      let that = this;

      let goods_items = [
        {
          goods_id: data.goodsId,
          sku_id: data.selectedSkuComb.id,
          count: data.selectedNum
        }
      ];
      // 存入缓存
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );

      that.$router.push({
        path: "/ordercheck"
      });
    },

    // 加入购物车
    onAddCartClicked(data) {
      let that = this;
      let goods_items = {
        goods_id: data.goodsId,
        sku_id: data.selectedSkuComb.id,
        count: data.selectedNum
      };

      this.$api.post(
        "/api/cart/add",
        goods_items,
        res => {
          that.cart_count = that.cart_count + data.selectedNum;
          this.$toast("添加成功");
          that.showSkuPicker = false;
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
            that.showSkuPicker = false;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    goCart() {
      localStorage.setItem("_self_cart", "cart");
      this.$router.push({
        path: "/self/index?business_id=" + this.detail.business_id
      });
    },

    goBusiness() {
      this.$router.push({
        path: "/self/index?business_id=" + this.detail.business_id
      });
    },
    goOrderList() {
      this.$router.push({ path: "/orderlist" });
    },

    goHome() {
      this.$router.push({
        path: "/self/index",
        query: {
          business_id: this.detail.business_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// GoodsDetailSellerShare.vue?b13351a6